import { Divider, Label } from 'semantic-ui-react'
import styled from 'styled-components'

export const FeedWrapper = styled.div`
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
  flex-direction: column;
  .feed-title {
    font-size: 13px !important;
  }
  .title {
    font-weight: bold;
    font-size: 14px !important;
    padding-bottom: 0px !important;
    border: none !important;
  }
  .active-feed {
    background: ${props => props.theme.firstColor} !important;
    color: white !important;
    font-weight: bold;
    &:hover {
      font-weight: bold;
      background: ${props => props.theme.secondColor} !important;
    }
  }
  .disabled {
    &:hover {
      cursor: default;
      background: initial !important;
      color: rgba(0,0,0,.87) !important;
   }
  }
`

export const StyledFeed = styled(Label) <{ $smallFont?: boolean }>`
 border: 1px solid ${props => props.theme.firstColor} !important;
 font-size: ${props => props.$smallFont ? '13px' : '14px'} !important;
 font-weight: normal !important; 
 &:hover {
  background: ${props => props.theme.firstColor} !important;
  color: white !important;
 }
 cursor: pointer;
`
export const StyledDivider = styled(Divider)`
background: ${props => props.theme.firstColor} !important;
margin-top: -6px !important;
margin-bottom: 0px !important;
`

export const PhaseWrapper = styled.div`
width: fit-content;
  .ui.divider {
    margin-top: 3px !important;
    background: ${props => props.theme.firstColor} !important;
  }
`
export const PhaseContentWrapper = styled.div`
display: flex;
flex-direction: column;
 .title {
  width: fit-content;
  font-weight: bold;
  font-size: 15px !important;
 }
 
 .thicker-divider {
  border-top: 2px solid rgba(34, 36, 38, .15) !important;
}

 .ui.divider {
  margin-top: 3px !important;
  background: ${props => props.theme.firstColor} !important;  
}
  .phase-row {
    display: flex;
    align-content: center;
    gap: 30px;
  }
`
export const PhaseGroup = styled.div`
display: flex;
align-items: baseline;
gap: 20px;
 .ui.selection.dropdown {
  min-width: 170px !important;
} 
.field {
  margin-left: 10px !important;

  &:first-child {
    margin-left: 0 !important;
  }
}
 label {
  font-weight: normal !important;
  color: initial !important;
 }
`